import { __rest } from "tslib";
import React from 'react';
import ClientImage from './components/ClientImage/index';
import NextImage from './components/NextImage/index';
const Image = (_a) => {
    var { src = '', url = '', width, height, children, layout, hasPriority = false, objectPosition = '50% 50%', objectFit = 'fill', shouldUseNextImage = false, nextImageSizes, nextImageQuality } = _a, props = __rest(_a, ["src", "url", "width", "height", "children", "layout", "hasPriority", "objectPosition", "objectFit", "shouldUseNextImage", "nextImageSizes", "nextImageQuality"]);
    // Do not remove environment flag due to tree shaking
    // NextImage should not be a part of the client-side bundle
    if (process.env.TYPE_OF_IMAGE === 'server' && shouldUseNextImage) {
        const { altText } = props, restProps = __rest(props, ["altText"]);
        let nextProps = Object.assign({ src: src || url, layout,
            hasPriority, quality: nextImageQuality, alt: altText, objectFit,
            objectPosition }, restProps);
        if (!width && !height) {
            nextProps = Object.assign(Object.assign(Object.assign({}, nextProps), { layout: 'fill', objectFit,
                objectPosition }), (nextImageSizes && {
                sizes: nextImageSizes,
            }));
        }
        return React.createElement(NextImage, Object.assign({}, nextProps), children);
    }
    const imageProps = Object.assign({ url,
        width, height: height ? height.toString() : undefined }, props);
    return React.createElement(ClientImage, Object.assign({}, imageProps), children);
};
export default Image;
//# sourceMappingURL=Image.js.map